var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9267 36.1559L25.9267 44.9559C24.7264 45.6161 23.2717 45.6161 22.0714 44.9559L6.07135 36.1559C4.79316 35.4529 3.99902 34.1098 3.99902 32.6511V17.3812C3.99902 15.9225 4.79316 14.5794 6.07135 13.8764L22.0713 5.07636C23.2717 4.41618 24.7222 4.41389 25.9225 5.07407L41.9285 13.8774C43.2067 14.5804 43.999 15.9219 43.999 17.3807V32.6522C43.999 34.111 43.2049 35.4529 41.9267 36.1559ZM19.7502 10.9181L23.999 8.58122L37.2648 15.8774L32.9859 17.7956L19.7502 10.9181ZM15.5358 13.236L10.7333 15.8774L23.999 21.8244L28.3287 19.8834L15.5358 13.236ZM7.99902 19.0352L7.99903 32.6511L21.999 40.3511V25.3113L7.99902 19.0352ZM25.999 40.3511L39.999 32.651L39.999 19.0352L25.999 25.3113V40.3511Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOther);
export default __webpack_public_path__ + "static/media/iconOther.ff6ca71f062683f96070935e3680d16d.svg";
export { ForwardRef as ReactComponent };